import { Component } from "react";
import { withRouter } from "../../../withRouter";
import axios from "axios";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import $ from "jquery";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { ecommerceapiUrl, clientheaderconfig } from "../../Helpers/Config";
import {
  showLoader,
  hideLoader,
  showAlert,
  isEmpty,
  isSingleSelect,
} from "../../Helpers/SettingHelper";
import PageLoader from "../../Helpers/PageLoader";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Editor from "../Layout/Editor";
var module = "emailtemplate";
var moduleName = "Email Template";
var modulePath = "/clientpanel/emailtemplate";
class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editID: this.props.params?.EditID || '',
      pageloading: false,
      postdata: {
        emailSubject: "",
        emailContent: "",
        emailConfig: "",
        emailStatus: "",
        action: "add",
      },
      loading: true,
      formpost: [],
      companyDetail: [],
      kelyList: [],
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    this.loadkelyList();
    if (this.state.editID !== "") {
      const params = {
        url: `${ecommerceapiUrl}${module}/detail/${this.state.editID}`,
        type: "client",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost !== nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        const errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.props.navigate(modulePath);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (
      this.state.companyDetail !== nextProps.detaildata &&
      this.state.editID !== ""
    ) {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;

          var emailStatus =
            result.emailStatus === "A" ? "Active" : "Inactive";
          var status =
            result.emailStatus !== "" && result.emailStatus !== null
              ? [
                  {
                    label: emailStatus,
                    value: result.emailStatus,
                  },
                ]
              : [];
          var clientupdatedata = {
            emailSubject: result.emailSubject,
            emailContent: result.emailContent !== null ? result.emailContent : "",
            emailConfig:
              result.emailConfig !== "" && result.emailConfig !== null
                ? {
                    label: result.emailConfig,
                    value: result.emailConfig,
                  }
                : "",
            emailStatus: status,
            action: "edit",
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.props.navigate(modulePath);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }
  loadkelyList() {
    var urlShringTxt = ecommerceapiUrl + "emailtemplate/keylist";
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ kelyList: res.data.result });
      }
    });
  }
  sateValChange = (field, value) => {};

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(
      update(this.state, { postdata: { [field]: { $set: value } } })
    );
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.postdata;
    const editorContent = $('#editorContent').val();
    var postObject = {
      emailSubject: postData.emailSubject,
      emailContent: editorContent,
      emailConfig:postData.emailConfig?.value ?? "",
      emailStatus:postData.emailStatus?.value ?? "A",
    };

    var post_url = module;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = 'update';
    }
    this.props.getFormPost(postObject, post_url, "client", method, 'ecom');
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"emailtemplate"} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">
                      {this.state.editID !== "" ? "Update" : "Add New"}{" "}
                      {moduleName}
                    </h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={modulePath}>
                      <button
                        type="button"
                        className="btn btn-outline-primary waves-effect"
                      >
                        Back
                      </button>
                    </Link>
                  </div>
                </div>
                <PostForm
                  {...this.props}
                  fields={this.state.postdata}
                  kelyList={this.state.kelyList}
                  onChange={this.fieldChange}
                  onValid={this.handleSubmit}
                  error_msg={this.state.error_msg}
                  onInvalid={() => {
                    console.log("Form invalid!");
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop:
                              $(document)
                                .find("#modulefrm .is-invalid:first")
                                .offset().top - 100,
                          },
                          500
                        );
                      }
                    }, 500);
                  }}
                />
              </div>
              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method, urlType) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method, urlType });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(Form));

function validationConfig(props) {
  const { emailSubject, emailConfig, emailStatus } = props.fields;

  return {
    fields: ["emailSubject", "emailConfig", "emailStatus"],

    validations: {
      emailSubject: [[isEmpty, emailSubject]],
      emailConfig: [[isSingleSelect, emailConfig]],
      emailStatus: [[isSingleSelect, emailStatus]]      
    },
  };
}

class PostForm extends Component {
  constructor(props) {
    super(props);
    this.setContent = this.setContent.bind(this);
  }

  handleChange(name, value) {
    this.props.onChange(name, value);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }
  setContent(value) {
    this.props.onChange("emailContent", value);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } =
      this.props;
    let errMsgSubject,
      errMsgConfigKey,
      /* errMsgContent, */ errMsgStatus = "";
    if ($validation.emailSubject.error.reason !== undefined) {
      errMsgSubject = $validation.emailSubject.show && (
        <span className="error">{$validation.emailSubject.error.reason}</span>
      );
    }
    if ($validation.emailConfig.error.reason !== undefined) {
      errMsgConfigKey = $validation.emailConfig.show && (
        <span className="error">
          {$validation.emailConfig.error.reason}
        </span>
      );
    }
   /*  if ($validation.emailContent.error.reason !== undefined) {
      errMsgContent = $validation.emailContent.show && (
        <span className="error">{$validation.emailContent.error.reason}</span>
      );
    }
 */
    if ($validation.emailStatus.error.reason !== undefined) {
      errMsgStatus = $validation.emailStatus.show && (
        <span className="error">{$validation.emailStatus.error.reason}</span>
      );
    }

    return (
      <form className="card fv-plugins-bootstrap5" id="modulefrm">
        <div className="card-body row g-3">
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={
                  errMsgSubject !== "" &&
                  errMsgSubject !== false &&
                  errMsgSubject !== undefined
                    ? "form-control is-invalid"
                    : "form-control"
                }
                name="emailSubject"
                value={fields.emailSubject}
                {...$field("emailSubject", (e) =>
                  onChange("emailSubject", e.target.value)
                )}
              />
              <label htmlFor="emailSubject">
                Subject <span className="error">*</span>
              </label>
              {errMsgSubject}
            </div>
          </div>
          <div
            className={
              errMsgConfigKey !== "" &&
              errMsgConfigKey !== false &&
              errMsgConfigKey !== undefined
                ? "col-md-6 error-select error"
                : "col-md-6"
            }
          >
            <div className="form-floating form-floating-outline custm-select-box">
              <Select
                value={fields.emailConfig}
                onChange={this.handleSelectChange.bind(
                  this,
                  "emailConfig"
                )}
                placeholder="Select Email Config Key"
                options={this.props.kelyList}
                isClearable={true}
              />
              <label className="select-box-label">
                Email Config Key<span className="error">*</span>
              </label>
              {errMsgConfigKey}
            </div>
          </div>
          <div className="col-md-12">
            <label>Description</label>
            <Editor IDName={"editorContent"} data={fields.emailContent} />
            {/* errMsgContent */}
          </div>
          <div
            className={
              errMsgStatus !== "" &&
              errMsgStatus !== false &&
              errMsgStatus !== undefined
                ? "col-md-6 error-select error"
                : "col-md-6"
            }
          >
            <div className="form-floating form-floating-outline custm-select-box">
              <Select
                value={fields.emailStatus}
                onChange={this.handleSelectChange.bind(this, "emailStatus")}
                placeholder="Select Status"
                options={[
                  { value: "A", label: "Active" },
                  { value: "I", label: "Inactive" },
                ]}
                isClearable={true}
              />
              <label className="select-box-label">
                Status<span className="error">*</span>
              </label>
              {errMsgStatus}
            </div>
          </div>
          <div className="pt-1 pb-4 pt-1 text-end">
            <button
              type="button"
              className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
              onClick={(e) => {
                e.preventDefault();
                this.props.$submit(onValid, onInvalid);
              }}
            >
              Submit
            </button>
            <Link to={modulePath}>
              <button
                type="reset"
                className="btn btn-label-secondary waves-effect"
              >
                Cancel
              </button>
            </Link>
          </div>
        </div>
      </form>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
